var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 24"}},_vm.$listeners),[_c('path',{attrs:{"fill":"#525C76","d":"M11 19V7.414l-5.293 5.293a1 1 0 1 1-1.414-1.414l7-7 .076-.068a1 1 0 0 1 1.338.068l7 7a1 1 0 1 1-1.414 1.414L13 7.414V19a1 1 0 1 1-2 0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }